import { useEffect } from 'react';

import { Redirect, Route, Switch } from 'react-router-dom';

import NotFound from '@/components/NotFound';
import useIsMultipleTeamsEnabled from '@/hooks/useIsMultipleTeamsEnabled';
import useIsTeamsEnabled from '@/hooks/useIsTeamsEnabled';
import useShowSuperuserUI from '@/hooks/useShowSuperuserUI';
import useUser from '@/hooks/useUser';
import { BasetenPageEnum, renderRoutes } from '@/routes';
import PaymentMethodDialog from '@/sections/Billing/PaymentMethodDialog';
import BillBar from '@/sections/Billip/BillBar/lazy';
import { useSegmentIdentify, useSegmentPageViews } from '@/utils/analytics/segment/hooks';
import { usePylon } from '@bolasim/react-use-pylon';

import PageComponents from './PageComponents';
import Routes from './routes';
import { Container, Content } from './styled';

function Creator() {
  const user = useUser();
  useSegmentIdentify();
  useSegmentPageViews();
  const { update: updatePylon } = usePylon();
  const showSuperuserUI = useShowSuperuserUI();
  const isTeamsEnabled = useIsTeamsEnabled();
  const isMultipleTeamsEnabled = useIsMultipleTeamsEnabled();

  useEffect(() => {
    if (ENV_CONFIG.PYLON_APP_ID) {
      // Update Pylon with user's information
      updatePylon({
        name: [user.firstName, user.lastName].join(' '),
        email: user.email,
      });
    }
  }, [user, updatePylon]);

  if (!isMultipleTeamsEnabled) {
    PageComponents[BasetenPageEnum.TeamSettings] = () => (
      <NotFound sx={{ background: 'transparent' }} />
    );
  }

  return (
    <Container>
      <Content>
        {showSuperuserUI && <BillBar />}
        <Switch>
          {/* The following redirects are needed to support the old model managment routes */}
          <Redirect from="/models/:model_id/versions/:version_id" to="/models/:model_id" exact />
          <Redirect
            from="/models/:model_id/versions/:version_id/overview"
            to="/models/:model_id"
            exact
          />
          <Redirect
            from="/models/:model_id/versions/:version_id/:tab_id"
            to="/models/:model_id/:tab_id/:version_id"
          />
          {isTeamsEnabled && [
            <Redirect key="redirect-models" from="/models" to="/overview" exact />,
            <Redirect key="redirect-chains" from="/chains" to="/overview" exact />,
            <Redirect key="redirect-training" from="/training" to="/overview" exact />,
            <Redirect key="redirect-model-apis" from="/model-apis" to="/overview" exact />,
          ]}
          {/* ============================== */}
          {renderRoutes(Routes, PageComponents)}
          <Redirect from="/" to="/overview" />
          <Redirect from="/data" to="/data/database_models" />
          <Route component={NotFound} />
        </Switch>
      </Content>
      <PaymentMethodDialog />
    </Container>
  );
}

export default Creator;
